export function mod(a: number, b: number) {
  return ((a % b) + b) % b;
}

export function clamp(value: number, min: number, max: number) {
  return Math.max(min, Math.min(value, max));
}

export function clamp01(value: number) {
  return clamp(value, 0, 1);
}

export function lerp(a: number, b: number, t: number) {
  return a + (b - a) * t;
}
